// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".style_root__1kFuw {\n  display: flex;\n  flex-direction: column; }\n  .style_root__1kFuw .style_title__2WRZZ {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 11px;\n    line-height: 16px;\n    color: #464646; }\n  .style_root__1kFuw .style_input__1MQLD {\n    width: 100%;\n    border: none;\n    border-bottom: 2px solid #c6cad8;\n    outline: none;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 22px;\n    color: #333333;\n    background: inherit;\n    border-radius: 0; }\n    .style_root__1kFuw .style_input__1MQLD:focus {\n      border-bottom: 2px solid #333333; }\n", ""]);
// Exports
exports.locals = {
	"root": "style_root__1kFuw",
	"title": "style_title__2WRZZ",
	"input": "style_input__1MQLD"
};
module.exports = exports;
